import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
const colors = {
  information: Colors.advanceBlue400,
  success: Colors.success400,
  warning: Colors.warning400,
  error: Colors.error400
};
const StyledBadge = styled.View`
  border-radius: 100px;
  padding: 2px 6px;
  align-self: flex-start;
  background-color: ${_ref => {
  let {
    type
  } = _ref;
  return colors[type];
}};
  align-items: center;
  justify-content: center;
`;
export default function Badge(props) {
  const type = Object.keys(colors).includes(props.type) ? props.type : Badge.defaultProps.type;
  return /*#__PURE__*/React.createElement(StyledBadge, {
    type: type
  }, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    weight: "bold",
    color: Colors.white
  }, props.children));
}
Badge.defaultProps = {
  type: 'information',
  children: ''
};
Badge.propTypes = {
  type: PropTypes.oneOf(Object.keys(colors)),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
//# sourceMappingURL=index.js.map